import React from 'react';
import { FormProvider } from 'react-hook-form';
import { SubmitButton } from '../../../../../../../../components';
import { IntegratedTabsContent } from '../../../../../../../../components/integrated-tabs-content/integrated-tabs-content';
import { ChannelType } from '../../../../../../types/channel';
import { useMeterConfigurationContext } from '../../context';
import { useMeterConfiguration } from '../../hooks/use-meter-configuration';
import { useMeterConfigurationSubmit } from '../../hooks/use-meter-configuration-submit';
import { getErrorIndexes } from '../../utils';
import { EventingRuleForm } from '../eventing-rule-form/eventing-rule-form';

type MeterConfigurationFormProps = {
  channel: ChannelType;
};

export const MeterConfigurationForm: React.FC<MeterConfigurationFormProps> = ({ channel }) => {
  const { controlModeOptions, sourceThresholdOptions, setTimeoutError } = useMeterConfiguration(channel);
  const { activeRuleIndex, setActiveRuleIndex, form, formValues, serverErrors } = useMeterConfigurationContext();
  const { onSubmit } = useMeterConfigurationSubmit(channel, setTimeoutError);

  const errorIndexes = getErrorIndexes(form.formState.errors);

  const tabs = formValues.rules.map((_, index) => ({
    label: `${index + 1}`,
    error: !!errorIndexes[index] || !!serverErrors[index],
  }));

  if (!tabs.length) return null;

  return (
    <div className="p-l-24 p-r-24 m-b-48">
      <FormProvider {...form}>
        <form onSubmit={onSubmit}>
          <IntegratedTabsContent activeTabIndex={activeRuleIndex} setActiveTabIndex={setActiveRuleIndex} tabs={tabs}>
            {tabs.map((_, index) => (
              <EventingRuleForm
                key={index}
                index={index}
                controlModeOptions={controlModeOptions}
                sourceThresholdOptions={sourceThresholdOptions}
              />
            ))}
          </IntegratedTabsContent>
          <SubmitButton />
        </form>
      </FormProvider>
    </div>
  );
};
